import { RestService } from '../restService';
import { Session } from '../../models';

export class SessionService extends RestService<Session> {
    public constructor(baseUrl: string, baseRoute: string) {
        super(baseUrl, baseRoute);
    }

    // Backend route: GET /sessions/sessionId/:id
    public async get(id: string): Promise<Session> {
        const client = await this.axiosFactory();
        const response = await client.request<Session>({
            method: 'GET',
            url: `/sessionId/${id}`,
        });
        return response?.data as Session;
    }

    public async getNext(): Promise<Session[]> {
        const client = await this.axiosFactory();
        const response = await client.request<Session[]>({
            method: 'GET',
            url: '/next'
        });
        return response?.data || [];
    }

    public async getNextForClient(clientId: string): Promise<Session | null> {
        if (!clientId) return null;
        const client = await this.axiosFactory();
        const response = await client.request<Session | null>({
            method: 'GET',
            url: `/next/${clientId}`
        });
        return response?.data ?? null;
    }

    public async getByCreator(creatorId: string): Promise<Session[]> {
        if (!creatorId) return [];
        const client = await this.axiosFactory();
        const response = await client.request<Session[]>({
            method: 'GET',
            url: `/all/${creatorId}`,
        });
        return response?.data || [];
    }

    public async refreshByCreator(creatorId: string): Promise<void> {
        if (!creatorId) return;
        const client = await this.axiosFactory();
        await client.request<void>({
            method: 'POST',
            url: `/refresh/${creatorId}`,
        });
    }
}
